export const DEFAULT_LEVEL_FOR_USERS_WITH_NO_LEVEL = 1;

export const LOYALTY_LEVEL_TITLES: Record<number, string> = {
  1: 'New Partner',
  2: 'Growth Partner',
  3: 'Active Partner',
  4: 'Established Partner',
  5: 'Premium Partner',
  6: 'Top Partner',
};
